import "@hotwired/turbo-rails"
import "./controllers"

import "leaflet"

import * as Sentry from '@sentry/browser'
Sentry.init({
    dsn: process.env.SENTRY_URL,
    environment: process.env.RAILS_ENV
});
